<template>
  <div class="kd-image-list">
    <!-- <div class="kd-image-list__icon-wrapper kd-image-list__icon-wrapper--left">
      <div class="kd-image-list__icon kd-image-list__icon--left">L</div>
    </div>   -->
    <ul
      class="kd-image-list__list"
      :style="{
        height: componentHeight,
      }"
    >
    <li
        v-if="showSpinner"
        class="kd-image-list__list-item"
        style="position: relative"
      >
        <div class="kd-image-list__placeholder">
          <kd-spinner-circle :size="20" color="#C6C6C6"></kd-spinner-circle>
        </div>
      </li>
      <li
        v-for="imageUrl in reversedImageUrls"
        :key="imageUrl"
        class="kd-image-list__list-item"
        :class="{
          'kd-image-list__list-item--is-selected': imageUrl === selected,
        }"
        :style="{
          backgroundImage: `url(${fullImageUrl(imageUrl)})`,
        }"
        @click="itemClicked(imageUrl)"
      ></li>
    </ul>
    <!-- <div class="kd-image-list__icon-wrapper kd-image-list__icon-wrapper--right">
      <div class="kd-image-list__icon kd-image-list__icon--right">R</div>
    </div>   -->
  </div>  
</template>

<script>
import * as log from 'loglevel';
import KdSpinnerCircle from '@/components/KdSpinnerCircle.vue';

export default {
  model: {
    prop: 'selected',
    event: 'change',
  },
  props: {
    imageUrls: Array,
    selected: String,
    showSpinner: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    componentHeight() {
      if (this.imageUrls && this.imageUrls.length > 0) {
        return '70px'; // space for one image height and a bit of the next row (to notice the list is scrollable)
      }
      return '0px';
    },
    /**
     * New uploaded images should appear in the front
     */
    reversedImageUrls() {
      return this.imageUrls ? this.imageUrls.reverse() : [];
    },
  },
  methods: {
    fullImageUrl(imageUrl) {
      return process.env.VUE_APP_IMAGE_SERVER + imageUrl;
    },
    itemClicked(imageUrl) {
      this.$emit('change', imageUrl);
    }
  },
  components: {
    KdSpinnerCircle,
  },
}
</script>

<style lang="scss">
.kd-image-list {
  // height: 52px;
  // display: flex;
  position: relative;
  margin: 12px 0 20px 0;
}

.kd-image-list__icon-wrapper {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;

  &--left {
    left: -10px;
  }

  &--right {
    right: -10px;
  }
}

.kd-image-list__list {
  list-style-type: none;
  // height: see computed property
  
  // margin-between images added to width,
  // so the images take up the whole width
  // (invisible margin of right image overlaps the list)
  width: calc(100% + 9px);
  overflow: scroll;
}

.kd-image-list__list-item {
  display: inline-block;
  height: 38px; // TODO: Horizontal / vertical switch, based on input image
  width: 62px; // TODO
  background-color: #EDEDED;
  background-size: cover;
  cursor: pointer;
  margin-right: 9px;
  margin-bottom: 9px;
  border: 2px solid transparent;

  &--selected {
    border: 2px solid #01A4DD;
  }
}

.kd-image-list__placeholder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}
</style>
